export default function isValidJsonString(jsonStr) {
  return new Promise((resolve, reject) => {
    if (typeof jsonStr === 'string' && jsonStr !== '') {
      const parsedJson = JSON.parse(jsonStr);
      return resolve(parsedJson);
    } else {
      return reject();
    }
  });
}
